import * as React from 'react';

const ChevronDown = ({ size }: { size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

export default ChevronDown;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/Icon/ChevronDown.tsx